/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateEditVideoEditorEditsMutationRequest, CreateEditVideoEditorEditsMutationResponse } from "../models/CreateEditVideoEditorEdits";

export function getCreateEditVideoEditorEditsUrl() {
  const res = { method: 'POST', url: `/video-editor/edits` as const }
  return res
}

/**
 * @summary Create an edit from a source (response includes creator and published platforms)
 * {@link /video-editor/edits}
 */
export async function createEditVideoEditorEdits(data: CreateEditVideoEditorEditsMutationRequest, config: Partial<RequestConfig<CreateEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, CreateEditVideoEditorEditsMutationRequest>({ method : "POST", url : getCreateEditVideoEditorEditsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}